import { CSSProperties } from "react";
import { Modal, Box } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import styles from "./styles";

export interface SimpleModalProps {
  isOpen: boolean;
  handleClose: any;
  children: React.ReactNode;
  externalStyles?: CSSProperties;
  hideCloseButton?: boolean;
}

export const SimpleModal = ({
  isOpen,
  handleClose,
  children,
  externalStyles = {},
  hideCloseButton = false,
}: SimpleModalProps) => {
  return (
    <Modal
      open={isOpen}
      onClose={hideCloseButton ? undefined : handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={styles.modalContainer}
    >
      <Box sx={{ ...styles.modalStyle, ...externalStyles }}>
        {!hideCloseButton && (
          <CloseIcon sx={styles.closeButton} onClick={handleClose} />
        )}
        {children}
      </Box>
    </Modal>
  );
};

export default SimpleModal;
